import React, { useState, useRef, useEffect } from "react";
import { FormInputTextarea, FormLabel } from '../../../styles/Common'
import MandatoryMarker from '../MandatoryMarker';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
function Textarea({ text, maxLength, label,name, onChange }) {
    const [isTruncated, setIsTruncated] = useState(true);
    const textareaRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);


    const toggleTruncate = () => {
        setIsTruncated(!isTruncated);
    };
    const onChangeTextArea = (e) => {
        textareaRef.current.style.textAlign = "left";
        onChange(e)
        textareaRef.current.style.height = "auto";
        textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
       
    }
  

    useEffect(() => {
        if (textareaRef.current) {
            setIsOverflowing(textareaRef.current.scrollHeight > textareaRef.current.clientHeight);
          
        }
       
    }, [text]);

    useEffect(() => {
        if (textareaRef.current && !isTruncated) {
            textareaRef.current.style.height = "auto";
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        } else {
            textareaRef.current.style.height = "auto";
        }
    }, [isTruncated]);

 /*   const displayText = isTruncated ? text?.slice(0, maxLength) + "..." : text;*/
    const displayText = text;
    return (
        <div style={{ display: 'flex', width: '100%' }}>
            <FormLabel htmlFor={name} >{label}<MandatoryMarker /></FormLabel>
            <FormInputTextarea
                ref={textareaRef}
                value={displayText}
                onChange={onChangeTextArea}
                name={name}
                rows={1}
                style={{ textAlign: !isTruncated ? 'left' : 'right' }}
               />
          

            {
                isOverflowing && (
               
                    isTruncated ?
                        <>
                    <span>...</span>
                        <SkipNextIcon onClick={toggleTruncate} />
                    </>
                     :
                    <>
                         <SkipPreviousIcon onClick={toggleTruncate} />
                    </>
                
                )
            }
        </div>
    );
}
export default Textarea;

//{
//    text?.length > maxLength && (
//        <button onClick={toggleTruncate}>
//            {isTruncated ? "Show More" : "Show Less"}
//        </button>
//    )
//}